import React, { ReactElement } from 'react';
import WrappedAppbar from './components/WrappedAppbar';

interface Props {
    children: ReactElement;
}

const Navigation = (props: Props): ReactElement => {
    const { children } = props;
    return (
        <>
            <WrappedAppbar />
            {children}
        </>
    );
};

export default Navigation;
